import api from "../../lib/api/api";
import { SET_TEACHER_PROFILE, TEACHER_PROFILE_ERROR } from "./types";

export const fetchTeacherProfile = () => async (dispatch) => {
  try {
    const res = await api.get(`/teachers/teacher/profile`); // Token is attached automatically
    dispatch({
      type: SET_TEACHER_PROFILE,
      payload: res.data,
    });
    return { success: true, profile: res.data };
  } catch (error) {
    dispatch({
      type: TEACHER_PROFILE_ERROR,
      payload: error.response?.data || "Error fetching teacher profile",
    });
    return { success: false, message: error.response?.data?.message || error.response?.data || "Could not load teacher approval status." };
  }
};

export const updateTeacherProfile = (profile) => async (dispatch) => {
  const response = await api.put("/teachers/teacher/profile", profile);
  dispatch({ type: SET_TEACHER_PROFILE, payload: response.data });
  return response.data;
};

export const changeTeacherPassword = async (payload) => {
  const response = await api.put("/teachers/teacher/profile/password", payload);
  return response.data;
};

export const requestTeacherEmailChange = async (payload) => {
  const response = await api.post(
    "/teachers/teacher/profile/email-change/request",
    payload
  );
  return response.data;
};

export const confirmTeacherEmailChange = async (code) => {
  const response = await api.post(
    "/teachers/teacher/profile/email-change/confirm",
    { code }
  );
  return response.data;
};

export const uploadCurrentTeacherProfilePicture = (file) => async (dispatch) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await api.post(
    "/teachers/teacher/profile/picture",
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  dispatch({ type: SET_TEACHER_PROFILE, payload: response.data });
  return response.data;
};

export const uploadTeacherCV = (file) => async (dispatch) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    await api.post("/teachers/upload-cv", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return { success: true };
  } catch (error) {
    console.error("Upload failed:", error);
    return { success: false };
  }
};

export const submitTeacherApplication = (cvFile, certFile) => async (dispatch) => {
  const formData = new FormData();
  formData.append('cv', cvFile);
  formData.append('certificate', certFile);

  try {
    await api.post("/teachers/submit-application", formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    // Refresh profile so UI reflects applicationSubmitted=true
    await dispatch(fetchTeacherProfile());
    return { success: true };
  } catch (error) {
    console.error("Application submit failed:", error);
    return { success: false, message: error.response?.data || 'Submit failed' };
  }
};
